// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CaretUpFilledSvg from "@fishx/icons-svg/es/asn/CaretUpFilled";
import FishxIcon from '../components/FishxIcon';

var CaretUpFilled = function CaretUpFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CaretUpFilledSvg
  }));
};

CaretUpFilled.displayName = 'CaretUpFilled';
export default React.forwardRef(CaretUpFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CaretUpFilled.js
// module id = 2180
// module chunks = 0